import React from "react";
import { X } from "lucide-react";

export default function DeleteUserModal({
  isOpen,
  onClose,
  onConfirm,
  userName,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 animate-fade-in">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close modal"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Delete Icon */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="flex items-center justify-center xxl:max-w-[200px]">
              <img
                width="303"
                height="250"
                alt="delete"
                src="/images/delete-thumb.png"
              />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            Delete User?
          </h2>
          <p className="text-gray-600 text-sm">
            Are you sure want to delete User for this
            <br />
            User Management?
          </p>
        </div>

        {/* Buttons */}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="common-btn white-btn flex-1 px-6 py-3 border-2 border-teal-600 text-teal-600 font-semibold rounded-lg hover:bg-teal-50 transition-colors"
          >
            No
          </button>
          <button
            onClick={onConfirm}
            className="common-btn flex-1 px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}
